<template>
  <div>
    <span class="colored-name mt-2 cursor" @click="open">{{ text }}</span>
    <div id="myModal" class="modal" v-if="modalFlag">
      <div class="modal-content">
        <span class="close" @click="close">&times;</span>
        <p>{{ $i18n.t(question) }}</p>
        <div class="btn-group" role="group" aria-label="Basic example">
          <button type="button" @click="yes" class="btn btn-success">
            {{ $i18n.t(yesButtonLabel) }}
          </button>
          <button type="button" @click="no" class="btn btn-secondary">
            {{ $i18n.t(noButtonLabel) }}
          </button>
        </div>
      </div>
      <div></div>
    </div>
  </div>
</template>

<script>
/**
 * @class Confirmation
 *
 * @description This component renders the confirmation
 */
export default {
  name: 'confirmation',
  components: {},
  props: {
    link: {
      type: String,
      required: false,
    },
    rowId: {
      type: Number,
      required: false,
    },
    text: {
      type: String,
      required: false,
    },
    status: {
      type: Number,
      required: false,
    },
    question: {
      type: String,
      required: false,
    },
    yesButtonLabel: {
      type: String,
      required: false,
    },
    noButtonLabel: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      modalFlag: false,
    }
  },
  methods: {
    close() {
      this.modalFlag = false
    },
    open() {
      this.modalFlag = true
    },
    yes() {
      location.href = this.link
    },
    no() {
      this.modalFlag = false
      this.$emit('listModalClose')
    },
  },
}
</script>
<style scoped>
/* The Modal (background) */
.modal {
  display: inline-flex;
  position: fixed; /* Stay in place */
  z-index: 999; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.3); /* Black w/ opacity */
}
/* Modal Content */
.modal-content {
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 40%;
}
/* The Close Button */
.close {
  color: #000;
  font-size: 28px;
  font-weight: bold;
  width: 100%;
  text-align: right;
}
.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
.cursor {
  cursor: pointer;
}
</style>
